import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics, BaseModel, BasesController } from '../../libraries';

@BindAll()
export class ProtocolController<T = any> extends BasesController<T> {
  Model = new BaseModel({ type: 'object' });

  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.legal_portal_protocol_find,
      paginationParams: {
        currentKey: 'curPageNo',
        pageSizeKey: 'pageSize',
        response: {
          dataSource: 'data',
        },
      },
    });
  }

  /**
   * 协议列表
   */
  @computed
  get protocolList(): Array<any> {
    return lodash.get(this.Model.value, 'protocolList', []);
  }

  /**
   * 获取协议，传sceneCode场景值获取，枚举值从EnumProtocol获取
   * @memberof ProtocolController
   */
  async getProtocolList(sceneCode) {
    try {
      const res: any[] = await AjaxBasics.request<any>({
        ...EnumAPI.legal_portal_protocol_find,
        body: { sceneCode },
      });
      this.Model.merge({ protocolList: res });
      return res;
    } catch (error) {
      throw error;
    }
  }

  /**
   * 确认协议
   * @memberof ProtocolController
   */
  async onSaveProtocol(body) {
    try {
      const token = lodash.get(body, 'token');
      const headers = token
        ? {
            'bp-token': lodash.get(body, 'token'),
          }
        : {};
      return AjaxBasics.request<any>({
        ...EnumAPI.legal_portal_protocol_save,
        body: lodash.omit(body, ['token']),
        headers,
      });
    } catch (error) {
      console.log('error:', error);
      // throw error;
    }
  }
}
